import React, { useRef } from 'react';
import { useUnit } from 'effector-react';
import { Button } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import Slider from 'react-slick';
import style from '../Landing.module.css';
import { $language } from '../../../models/landingModel/index.js';
import { translation } from '../../../dictionaries/translation.js';
import features_1_en from '../../../assets/images/sections/features/features_1_en.png';
import features_2_en from '../../../assets/images/sections/features/features_2_en.png';
import features_3_en from '../../../assets/images/sections/features/features_3_en.png';
import features_4_en from '../../../assets/images/sections/features/features_4_en.png';
import features_1_ru from '../../../assets/images/sections/features/features_1_ru.png';
import features_2_ru from '../../../assets/images/sections/features/features_2_ru.png';
import features_3_ru from '../../../assets/images/sections/features/features_3_ru.png';
import features_4_ru from '../../../assets/images/sections/features/features_4_ru.png';
import useWindowSize from '../../../hooks/useWindowSize.js';

const features = {
  en: {
    features_1: features_1_en,
    features_2: features_2_en,
    features_3: features_3_en,
    features_4: features_4_en,
  },
  ru: {
    features_1: features_1_ru,
    features_2: features_2_ru,
    features_3: features_3_ru,
    features_4: features_4_ru,
  },
};

function Features(props) {
  const language = useUnit($language);
  const slickRef = useRef();
  const [width, height] = useWindowSize();

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: width <= 1200 ? 1 : 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    // cssEase: 'linear',
  };

  const featuresItems = [
    {
      tag: translation[language].features_1_tag,
      text: translation[language].features_1_text,
      imgSrc: features[language].features_1,
    },
    {
      tag: translation[language].features_2_tag,
      text: translation[language].features_2_text,
      imgSrc: features[language].features_2,
    },
    {
      tag: translation[language].features_3_tag,
      text: translation[language].features_3_text,
      imgSrc: features[language].features_3,
    },
    {
      tag: translation[language].features_4_tag,
      text: translation[language].features_4_text,
      imgSrc: features[language].features_4,
    },
  ];
  const prevSlide = () => {
    slickRef.current.slickPrev();
  };

  const nextSlide = () => {
    slickRef.current.slickNext();
  };

  return (
    <div className="landing_container">
      <div className={style.features_wrapper} id="features">
        <div className={style.features_top}>
          <div className={style.features_title}>
            {translation[language].features_title}
          </div>
          <div className={style.features_buttons_wrapper}>
            <Button
              shape="circle"
              icon={<LeftOutlined />}
              className={style.features_button}
              onClick={prevSlide}
            />
            <Button
              shape="circle"
              icon={<RightOutlined />}
              className={style.features_button}
              onClick={nextSlide}
            />
          </div>
        </div>
        <div className={`slider-container ${style.features_slider_wrapper}`}>
          <Slider {...settings} ref={slickRef}>
            {featuresItems.map((item) => {
              return <FeatureCard key={`feature-${item.tag}`} {...item} />;
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
}

function FeatureCard(props) {
  const { tag, text, imgSrc } = props;
  return (
    <div className={style.features_card}>
      <div>
        {/* <div className={style.features_tag}>{tag}</div> */}
        <div className={style.features_text}>{text}</div>
      </div>
      <img src={imgSrc} className={style.features_card_img} />
    </div>
  );
}

export default Features;
